module.exports = __webpack_public_path__ + "static/media/m-sphinx-treasure.6966bfe7.png";